import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "project-nav-list",
  class: "col-2"
}
const _hoisted_2 = {
  class: "nav flex-column nav-pills",
  role: "tablist",
  "aria-orientation": "vertical"
}
const _hoisted_3 = { class: "col-10 tab-content h-100" }
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "project-props-general",
  role: "tabpanel"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  class: "h-100 tab-pane fade",
  id: "project-props-chart",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BtnSubmit = _resolveComponent("BtnSubmit")!
  const _component_GanttChart = _resolveComponent("GanttChart")!

  return (_openBlock(), _createElementBlock("div", {
    class: "row h-100",
    onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.applyShortcut && _ctx.applyShortcut(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("a", {
          class: "nav-link active",
          id: "project-props-general-tab",
          "data-toggle": "pill",
          href: "#project-props-general",
          role: "tab",
          "aria-selected": "true"
        }, "General", -1)),
        _createElementVNode("a", {
          class: "nav-link",
          id: "project-props-chart-tab",
          "data-toggle": "pill",
          href: "#project-props-chart",
          role: "tab",
          "aria-selected": "false",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateGanttChart && _ctx.updateGanttChart(...args)))
        }, "Gantt Chart")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[4] || (_cache[4] = _createElementVNode("label", { for: "modal-project-name" }, "Name", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "modal-project-name",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.projectName) = $event))
          }, null, 512), [
            [_vModelText, _ctx.projectName]
          ])
        ]),
        _createVNode(_component_BtnSubmit, {
          title: "Apply",
          spinner: "",
          ref: "submitButton",
          "submit-handler": _ctx.updateProject
        }, null, 8, ["submit-handler"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_GanttChart, { ref: "ganttChart" }, null, 512)
      ])
    ])
  ], 32))
}